import { render, staticRenderFns } from "./AlbaranMaterialIncidence.vue?vue&type=template&id=48e18296&scoped=true"
import script from "./AlbaranMaterialIncidence.vue?vue&type=script&lang=js"
export * from "./AlbaranMaterialIncidence.vue?vue&type=script&lang=js"
import style0 from "./AlbaranMaterialIncidence.vue?vue&type=style&index=0&id=48e18296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e18296",
  null
  
)

export default component.exports